/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {GenericObject} from '@ion/core/src/types/entities';
import {TertiaryButton} from '../../components/buttons/TertiaryButton';

// defines the type definitions for export button ...
export interface ExportButtonProps {
  onExport: (item: GenericObject) => void;
  label: string;
  uppercase?: boolean;
};

/**
 * This component helps user to initiate download of import results and errors if any
 * as excel.
 *
 * ```typescript
 *
 *   import {ExportButton} from '@ion/dls/src/editors/controls';
 *
 *    <ExportButton label={translate('common:editors.import.results.downloadResults')}
 *      onExport={function() {onExport(false);}} />
 * ```
 */
export const ExportButton = (
  {onExport, label, uppercase}: ExportButtonProps
) => {
  return (
    <div>
      <TertiaryButton fullWidth uppercase={uppercase} onClick={onExport}>
        {label}
      </TertiaryButton>
    </div>
  );
};

export default ExportButton;
